import React from 'react';
import { Button, Upload } from 'antd';
import ImgCrop from 'antd-img-crop';
import { IconUpload } from '../../../../assets';
import { CONFIG_CONTAINER_NAME, uploadFileToBlob } from '../../../../utils/azure';

interface UploadImageProps {
  onGetUrlUploaded: (url: string) => void;
  folderUpload?: string;
}

export const UploadImage = (props: UploadImageProps) => {
  const { onGetUrlUploaded, folderUpload } = props;
  const action = {
    beforeUpload(file: any): Promise<any> {
      return new Promise(resolve => {
        const reader = new FileReader();
        reader.readAsDataURL(file);
        reader.onload = () => {
          const img = document.createElement('img');
          img.src = reader?.result ? reader?.result.toString() : '';
          img.onload = () => {
            const canvas = document.createElement('canvas');
            canvas.width = img.naturalWidth;
            canvas.height = img.naturalHeight;
            const ctx = canvas.getContext('2d');
            if (ctx) {
              ctx.drawImage(img, 0, 0);
            }
            canvas.toBlob(resolve);
          };
        };
      });
    },
    onRemove() {
      onGetUrlUploaded('');
    },
  };

  const uploadImage = async (options: any) => {
    const { onSuccess, onError, file } = options;
    try {
      const resultUpload = await uploadFileToBlob(
        [
          {
            blob: file,
            fileType: file.type,
            fileName: file.name,
          },
        ],
        folderUpload || CONFIG_CONTAINER_NAME.UPLOADS,
      );
      if (resultUpload && resultUpload.length > 0) {
        onGetUrlUploaded(resultUpload[0]);
        onSuccess('Image successfully uploaded.');
      }
    } catch (error) {
      onError({ error });
    }
  };

  const cropperProps = {
    cropperProps: {
      restrictPosition: false,
    },
  };

  return (
    <ImgCrop
      grid
      rotate
      onModalOk={() => {
        const imageBg = document.getElementsByClassName('fileName-bgImage-hidden');
        if (imageBg.length > 0) {
          imageBg[0].classList.remove('fileName-bgImage-hidden');
        }
      }}
      modalWidth={1000}
      minZoom={0.5}
      {...cropperProps}
    >
      <Upload {...action} maxCount={1} customRequest={uploadImage}>
        <Button icon={<IconUpload />} className="UploadImage" />
      </Upload>
    </ImgCrop>
  );
};
